module.exports = __webpack_public_path__ + "static/sui-table-contextual-styles2-63e5dc847e18a6e0005dae57117144aa.png";